import React, { useState, useEffect } from "react";
import {
  Button,
  FormControl,
  FormLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  IconButton,
  InputAdornment,
} from "@material-ui/core";
import useStyles from "../../../../styles";
import axios from "axios";
import { decryptData } from "../../../../crypto";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import AddBoxOutlinedIcon from "@material-ui/icons/AddBoxOutlined";
import IndeterminateCheckBoxOutlinedIcon from "@material-ui/icons/IndeterminateCheckBoxOutlined";
import { Autocomplete } from "@material-ui/lab";

function AddSubjectForm() {
  const classes = useStyles();

  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const navigate = useNavigate();

  const [sections, setSections] = useState([{ name: "" }]);

  // const [courses, setCourses] = useState([]);
  // const [selectedCourse, setSelectedCourse] = useState("");
  // const [batches, setBatches] = useState([]);
  // const [selectedBatch, setSelectedBatch] = useState("");
  const [subjects, setSubjects] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState([]);

  const handleClose = () => {
    navigate("/admin/section");
  };

  const menuProps = {
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left",
    },
    disablePortal: true,
  };

  const handleAddLink = () => {
    setSections((prevLinks) => [...prevLinks, { name: "" }]);
  };

  const handleRemoveLink = (index) => {
    setSections((prevLinks) => {
      const updatedLinks = [...prevLinks];
      updatedLinks.splice(index, 1);
      return updatedLinks;
    });
  };

  // const handleCourceChange = (event, newValue) => {
  //   setSelectedCourse(newValue.id);
  // };

  // const handleBatchChange = (event, newValue) => {
  //   setSelectedBatch(newValue.id);
  // };

  const handleSubjectChange = (event, newValue) => {
    setSelectedSubject(newValue.id);
  };

  const handleFormSubmit = () => {
    if (!selectedSubject) {
      toast.warn("Please enter a Subject name.");
      return;
    }

    if (sections.some((p) => !p.name.trim())) {
      toast.warn("Please enter a section name.");
      return;
    }

    const section = sections?.map((s) => s.name);

    const data = {
      subjects_section: {
        subjects_id: selectedSubject,
        section_name: section,
      },
    };

    axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/subject_section/add`,
        data,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setTimeout(() => {
          navigate("/admin/section");
        }, 2000);
        toast.success("Section created successfully");
      })
      .catch((error) => {
        toast.error(error.response.data.message);
      });
  };

  // useEffect(() => {
  //   const fetchCourses = async () => {
  //     try {
  //       const response = await axios.get(
  //         `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/course/all/active`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${decryptedToken}`,
  //           },
  //         }
  //       );

  //       // Ensure that the API response contains the 'batch' property
  //       if (response.data && response.data.courses) {
  //         setCourses(response.data.courses);
  //       } else {
  //         console.error("Invalid API response format:", response);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching courses:", error);
  //     }
  //   };

  //   fetchCourses();
  // }, [decryptedToken]);

  // const fetchBatches = async (selectedCourse) => {
  //   try {
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/batch/by_course_id/${selectedCourse}`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${decryptedToken}`,
  //         },
  //       }
  //     );
  //     if (response.data && response.data.batches) {
  //       setBatches(response.data.batches);
  //     } else {
  //       console.error("Invalid API response format:", response);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching courses:", error);
  //   }
  // };

  // useEffect(() => {
  //   fetchBatches(selectedCourse);
  // }, [selectedCourse]);

  // const fetchSubjects = async (selectedBatch) => {
  //   try {
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/subject/by_batch/${selectedBatch}`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${decryptedToken}`,
  //         },
  //       }
  //     );
  //     if (response.data && response.data.subjects) {
  //       setSubjects(response.data.subjects);
  //     } else {
  //       console.error("Invalid API response format:", response);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching courses:", error);
  //   }
  // };

  // useEffect(() => {
  //   fetchSubjects(selectedBatch);
  // }, [selectedBatch]);

  const fetchSubjects = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/subject/active/list`,
          {
            headers: {
              Authorization: `Bearer ${decryptedToken}`,
            },
          },
        );
        if (response.data && response.data.subjects) {
        setSubjects(response.data.subjects);
      } else {
        console.error("Invalid API response format:", response);
      }
      } catch (error) {
        console.error("Error fetching data: ", error);
      }
    };
  
    useEffect(() => {
      fetchSubjects();
    }, []);

  return (
    <>
      <ToastContainer />

      <div
        className={`${classes.mt1} ${classes.mt1} ${classes.inputpadding} ${classes.inputborder} ${classes.pagescroll}`}
      >
        <FormControl className={`${classes.w100}`}>
          <div
            className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py2} ${classes.px1_5} ${classes.mt1}`}
          >
            <div
              className={`${classes.dflex} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              >
                Section Details
              </Typography>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Subject <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Autocomplete
                  id="state-autocomplete"
                  options={subjects || []}
                  // value={selectedSubject}
                  value={
                    subjects.find((sub) => sub.id === selectedSubject) || ""
                  }
                  classes={{ inputRoot: classes.inputRoot }}
                  onChange={handleSubjectChange}
                  disableClearable
                  getOptionLabel={(option) => option?.subject_name || ""}
                  autoHighlight
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Here"
                      variant="outlined"
                    />
                  )}
                  selectOnFocus
                  openOnFocus
                />
              </div>
               <div
                className={`${classes.w74} ${classes.dflex}  ${classes.flexwrapwrap} ${classes.ml1}`}
              >
                {sections.map((link, index) => (
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.mr0_5}  ${classes.w32}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Section Name{" "}
                      <span className={classes.textcolorred}>*</span>
                    </FormLabel>

                    <TextField
                      onChange={(e) => {
                        const updatedLinks = [...sections];
                        updatedLinks[index].name = e.target.value;
                        setSections(updatedLinks);
                      }}
                      value={link.name}
                      type="text"
                      variant="outlined"
                      required
                      placeholder="Enter Name"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            {sections.length >= 2 && (
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={() => handleRemoveLink(index)}
                                edge="end"
                              >
                                <IndeterminateCheckBoxOutlinedIcon />
                              </IconButton>
                            )}
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>
                ))}
                <div
                  className={`${classes.inputcontainer} ${classes.justifyflexend} ${classes.dflex}`}
                >
                  <IconButton onClick={handleAddLink}>
                    <AddBoxOutlinedIcon />
                  </IconButton>
                </div>
              </div>

              {/* <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Course <span className={classes.textcolorred}>*</span>
                </FormLabel>

                <Autocomplete
                  id="tags-standard"
                  options={courses}
                  getOptionLabel={(option) => option.course_name}
                  value={courses.find((sub) => sub.id === selectedCourse) || ""}
                  onChange={handleCourceChange}
                  disableClearable
                  forcePopupIcon={false}
                  renderInput={(params) => (
                    <TextField
                      name="section"
                      type="text"
                      variant="outlined"
                      placeholder="Type to pick course..."
                      {...params}
                    />
                  )}
                />
              </div> */}

              {/* <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Batch <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Autocomplete
                  id="state-autocomplete"
                  options={batches || []}
                  // value={selectedSubject}
                  value={batches.find((sub) => sub.id === selectedBatch) || ""}
                  classes={{ inputRoot: classes.inputRoot }}
                  onChange={handleBatchChange}
                  disableClearable
                  getOptionLabel={(option) => option?.batch_name || ""}
                  autoHighlight
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Here"
                      variant="outlined"
                    />
                  )}
                  selectOnFocus
                  openOnFocus
                />
              </div> */}

              
            </div>
            {/* <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>

             
            </div> */}
          </div>
          <div
            className={`${classes.dflex} ${classes.justifyflexend} ${classes.mt1}`}
          >
            <Button
              className={`${classes.custombtnoutline}`}
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              onClick={handleFormSubmit}
              className={`${classes.custombtnblue}`}
            >
              Submit
            </Button>
          </div>
        </FormControl>
      </div>
    </>
  );
}
export default AddSubjectForm;
